module.exports = __webpack_public_path__ + "vue/img/descargar-pdf.8c82f0e3.png";